export class UserProfileError extends Error {
  constructor(message: string, originalError: Error) {
    super(message)
    this.name = 'UserProfileError'
    this.stack = originalError.stack
  }
}
